<template>
  <Teleport to="body">
    <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content plan-edit-modal"
      overlay-class="vfm__overlay" :click-to-close="true" :lock-scroll="true" :hide-overlay="false" :esc-to-close="true"
      @click:overlay="closeModal" @click="handleOutsideClick" @before-open="beforeOpen" @before-close="beforeClose">
      <div class="content p-3" @click.stop>
        <div class="container pt-3">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div class="form-body">
                    <div class="row" v-if="Object.keys(errors._errors).length > 0">
                      <div class="col-md-12">
                        <div class="alert alert-warning">
                          <ul>
                            <li v-for="(error, key) in errors._errors" :key="key">
                              {{ error }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <label class="form-label">利用者</label>
                        <div class="mb-3" :class="{ 'is-invalid': errors?.has('user') }">
                          <user-search :office-id="officeId" :users="users" name="user" v-validate="'required'"
                            v-model="inputs.user" :editable="editable" data-vv-as="利用者" data-vv-validate-on="none" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-5">
                            <label class="form-label">日時</label>
                            <div class="input-group">
                              <div style="width: 170px" class="mb-3"
                                :class="{ 'is-invalid': errors?.has('start_day') }">
                                <input class="form-control" type="date" v-model="inputs.start_day">
                                <input type="hidden" name="startDay" v-model="inputs.start_day" v-validate="'required'"
                                  data-vv-as="日付" data-vv-validate-on="none">
                              </div>
                              <div style="width: 110px" class="mb-3"
                                :class="{ 'is-invalid': errors?.has('start_hhmm') }">
                                <input class="form-control" type="time" name="startHhmm" v-validate="'required'"
                                  v-model="inputs.start_hhmm" data-vv-as="開始時刻" data-vv-validate-on="none">
                              </div>
                              <div style="line-height: 38px;">〜</div>
                              <div style="width: 110px" class="mb-3" :class="{ 'is-invalid': errors?.has('end_hhmm') }">
                                <input class="form-control" type="time" name="endHhmm" v-validate="'required'"
                                  v-model="inputs.end_hhmm" data-vv-as="終了時刻" data-vv-validate-on="none">
                              </div>
                            </div>
                          </div>
                          <div class="col-md-7">
                            <label class="form-label">サービスコード</label>
                            <div class="input-group" v-if="isSakura">
                              <div style="width:300px;">
                                <select-code :code-group="SPECIFIC_OFFICE_ADDITION_CD"
                                  v-model="inputs.specific_office_addition_cd" name="specific_office_addition_cd"
                                  data-vv-as="特定事業者加算" data-vv-validate-on="none" />
                              </div>
                            </div>
                            <div class="input-group">
                              <div style="width: 200px" :class="{ 'is-invalid': errors?.has('service_type_id') }">
                                <select-service-type name="serviceTypeId" v-model="inputs.service_type_id"
                                  v-validate="'required'" data-vv-as="サービス種別" data-vv-validate-on="none" />
                              </div>
                              <template v-if="isSakura">
                                <select-service-code v-if="inputs.service_type_id !== Number(serviceTypeIdUniqueCode)"
                                  :service-type-id="inputs.service_type_id"
                                  :specific-office-addition-cd="inputs.specific_office_addition_cd"
                                  :target-date="inputs.start_day" v-model="inputs.service_code_id" />
                                <select-service-unique-code v-else :service-type-id="inputs.service_type_id"
                                  v-model="inputs.service_unique_code_id" />
                              </template>
                              <template v-else-if="isTeresaStandard">
                                <select-service-code v-if="inputs.service_type_id !== Number(serviceTypeIdUniqueCode)"
                                  :service-type-id="inputs.service_type_id"
                                  :specific-office-addition-cd="inputs.specific_office_addition_cd"
                                  :target-date="inputs.start_day" v-model="inputs.service_code_id" />
                                <select-service-teresa-unique-code v-else :service-type-id="inputs.service_type_id"
                                  v-model="inputs.service_teresa_unique_code_id" />
                              </template>
                              <template v-else>
                                <template v-if="isNativeCode">
                                  <select-service-code v-if="inputs.service_type_id !== Number(serviceTypeIdUniqueCode)"
                                    :service-type-id="inputs.service_type_id" :target-date="inputs.start_day"
                                    v-model="inputs.service_code_id" />
                                  <select-service-teresa-unique-code v-else :service-type-id="inputs.service_type_id"
                                    v-model="inputs.service_teresa_unique_code_id" />
                                </template>
                                <template v-else>
                                  <select-service-code :service-type-id="inputs.service_type_id"
                                    :target-date="inputs.start_day" v-model="inputs.service_code_id" />
                                </template>
                              </template>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-3">
                            <div class="input-group m-l-10">
                              <input class="form-check-input" id="ownExpenseFlag" type="checkbox"
                                v-model="inputs.ownExpenseFlag" />
                              <label class="form-check-label" for="ownExpenseFlag">自費サービス</label>
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="input-group" v-if="isTaxi">
                              <div class="form-check">
                                <input class="form-check-input" id="wheelchairTaxiFlag" type="checkbox"
                                  v-model="inputs.wheelchairTaxiFlag" />
                                <label class="form-check-label" for="wheelchairTaxiFlag">車いすタクシー</label>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 col-md-offset-4" v-if="isSakura">
                            <label class="form-label">加算項目</label>
                            <div class="input-group">
                              <div style="width: 260px" class="mb-3">
                                <select-code :code-group="ADDITION" v-model="inputs.special_addition_cd"
                                  name="special_addition_cd" data-vv-as="加算項目" data-vv-validate-on="none" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="m-l-10">
                              <label class="form-label">行き先</label>
                              <div class="input-group">
                                <input type="text" class="form-control" maxlength="60" v-model="inputs.destination"
                                  v-validate="'max:60'" name="props.plan.service.destination"
                                  :class="{ 'is-invalid': errors?.has('props.plan.service.destination') }"
                                  data-vv-as="行き先" data-vv-validate-on="none" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-8">
                        <div class="card-body">
                          <!-- Nav tabs -->
                          <ul class="nav nav-tabs customtab" role="tablist">
                            <li class="nav-item">
                              <a class="nav-link active" data-toggle="tab" href="#details" role="tab"
                                aria-controls="details" aria-selected="true">
                                詳細設定
                              </a>
                            </li>
                          </ul>
                          <!-- Tab panes -->
                          <div class="tab-content pt-3">
                            <div class="tab-pane active" id="details" role="tabpanel">
                              <div class="row">
                                <div class="col-md-12">
                                  <select-care-items :service-type-id="inputs.service_type_id"
                                    v-model="inputs.service_items" />
                                </div>
                              </div>
                              <div class="row pt-3">
                                <div class="col-md-12">
                                  <div class="mb-3" :class="{ 'is-invalid': errors?.has('instruction') }">
                                    <label class="form-label">指示事項</label>
                                    <textarea class="form-control" rows="5" v-model="inputs.instruction"></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="card-body">
                          <ul class="nav nav-tabs customtab" role="tablist">
                            <li class="nav-item">
                              <a class="nav-link active" data-toggle="tab" href="#staff" role="tab"
                                aria-controls="staff" aria-selected="true">
                                <i class="ti-home d-sm-none"></i>
                                <span class="d-none d-sm-block">担当者</span>
                              </a>
                            </li>
                          </ul>
                          <div class="tab-content pt-3">
                            <div class="tab-pane active" id="staff" role="tabpanel">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="form-group">
                                    <staff-search :staffs="staffs" name="staff1" v-validate="'required'"
                                      v-model="inputs.staff1" data-vv-as="担当者1" data-vv-validate-on="none"
                                      v-if="isShiftMode" />
                                    <staff-search :staffs="staffs" name="staff1" v-model="inputs.staff1" v-else />
                                    <staff-search :staffs="staffs" name="staff2" v-model="inputs.staff2" />
                                    <staff-search :staffs="staffs" name="staff3" v-model="inputs.staff3" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="form-actions actions">
                    <div class="row">
                      <div class="col-md-12 text-right">
                        <a href="#" @click.prevent="close">キャンセル</a>
                        <template v-if="id">
                          <span class="mx-2"></span>
                          <button type="button" class="action-button btn btn-danger btn-rounded"
                            :disabled="isProcessing || isLoading || (plan && plan.reports && plan.reports.length > 0)"
                            @click="showDeleteModal = true">
                            削除する
                          </button>
                        </template>
                        <span class="mx-2"></span>
                        <button type="submit" :disabled="isProcessing || isLoading"
                          class="action-button btn btn-success btn-rounded" @click.prevent="register">
                          登録する
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <loading-modal v-model="isProcessing" message="更新中..." />
      <loading-modal v-model="isLoading" message="読込中..." />

      <!-- Delete Confirmation Modal -->
      <BModal v-model="showDeleteModal" title="確認" @ok="destroy" ok-title="はい" cancel-title="キャンセル" ok-variant="danger">
        <p>削除してもよろしいですか？</p>
      </BModal>
    </vue-final-modal>
  </Teleport>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
import { VueFinalModal } from 'vue-final-modal'
import { BModal } from 'bootstrap-vue-next'
import Constants from '../constants'
import SelectCareItems from '../components/SelectCareItems'
import SelectCode from '../components/SelectCode'
import SelectServiceType from '../components/SelectServiceType'
import SelectServiceCode from '../components/SelectServiceCode'
import SelectServiceUniqueCode from '../components/SelectServiceUniqueCode'
import SelectServiceTeresaUniqueCode from '@/components/SelectServiceTeresaUniqueCode'
import LoadingModal from '../components/LoadingModal'
import StaffSearch from './StaffSearch'
import UserSearch from './UserSearch'
import 'bootstrap/dist/css/bootstrap.css'
import 'jquery/dist/jquery.min.js'
import 'popper.js/dist/umd/popper.min.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import utils from '@/libs/Utils'
import api from '@/libs/Api'
import { useToast } from 'vue-toastification'

// Constants
const SPECIFIC_OFFICE_ADDITION_CD = computed(() => Constants.Code?.SPECIFIC_OFFICE_ADDITION_CD || {})
const ADDITION = computed(() => Constants.Code?.ADDITION || {})

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  name: String,
  officeId: [String, Number],
  staffs: Array,
  users: Array,
  editable: Boolean,
  plan: {
    type: Object,
    default: () => null
  },
  isShiftMode: {
    type: Boolean,
    default: false
  },
  params: {
    type: Object,
    default: () => null
  }
})

const emit = defineEmits(['update:modelValue', 'close', 'cancel', 'refresh-data', 'update:staffs'])

const store = useStore()
const profile = computed(() => store.state.session.profile)

// State
const errors = ref({
  has: (field) => field in errors.value._errors,
  _errors: {}
})

const resetFormErrors = () => {
  // Reset form errors
  errors.value._errors = {}
}

// State refs
const id = ref(null)
const isLoading = ref(false)
const isProcessing = ref(false)
const plan = ref(null)
const isUpdated = ref(false)
const isShiftMode = ref(false)
const isTaxi = ref(false)
const isSakura = ref(false)
const isNativeCode = ref(false)
const isTeresaStandard = ref(false)

const showModal = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
  }
})

const showDeleteModal = ref(false)
const serviceTypeIdUniqueCode = ref(Constants.Code.ServiceType.UNIQUE_CODE)

/**
 * 画面は開始日のみ編集可能だが API には start_day / end_day の両方が必要。
 * end_day を内部状態に依存させると、params で start だけ渡したとき等に開始日と不整合になり日マタギ扱いになる。
 * PlanEdit.vue の convertInputs2Plan と同じく、時刻から終了日を算出する。
 */
const computeServiceEndDayYmd = (input) => {
  const startDay = (input.start_day || '').replace(/-/g, '')
  if (!startDay) return ''
  let endDay = startDay
  const startHhmm = (input.start_hhmm || '').replace(':', '')
  const endHhmm = (input.end_hhmm || '').replace(':', '')
  if (startHhmm && endHhmm && Number(startHhmm) > Number(endHhmm)) {
    endDay = dayjs(startDay, 'YYYYMMDD').add(1, 'day').format('YYYYMMDD')
  }
  return endDay
}

const inputs = ref({
  start_day: null,
  start_hhmm: null,
  end_day: null,
  end_hhmm: null,
  service_type_id: null,
  specific_office_addition_cd: null,
  service_type_group_id: null,
  service_code_id: null,
  service_unique_code_id: null,
  service_teresa_unique_code_id: null,
  special_addition_cd: null,
  instruction: null,
  service_items: [],
  user: null,
  staff1: null,
  staff2: null,
  staff3: null,
  ownExpenseFlag: false,
  wheelchairTaxiFlag: false,
  destination: null
})

const convertPlan2Inputs = (plan) => {
  if (!plan || !plan.service) {
    console.error('PlanEditModal - Invalid plan data:', plan)
    return {
      start_day: dayjs().format('YYYY-MM-DD'),
      start_hhmm: null,
      end_day: dayjs().format('YYYY-MM-DD'),
      end_hhmm: null,
      service_type_id: null,
      service_type_group_id: null,
      service_code_id: null,
      service_unique_code_id: null,
      service_teresa_unique_code_id: null,
      special_addition_cd: '000',
      specific_office_addition_cd: '000',
      ownExpenseFlag: false,
      wheelchairTaxiFlag: false,
      destination: '',
      instruction: '',
      user: store.state.careplan.targetUserId,
      service_items: [],
      staff1: null,
      staff2: null,
      staff3: null
    }
  }

  try {
    // Format dates
    const startDay = plan.service.start_day
      ? (typeof plan.service.start_day === 'string'
        ? dayjs(plan.service.start_day).format('YYYY-MM-DD')
        : dayjs(plan.service.start_day.toString()).format('YYYY-MM-DD'))
      : dayjs().format('YYYY-MM-DD')

    const endDay = plan.service.end_day
      ? (typeof plan.service.end_day === 'string'
        ? dayjs(plan.service.end_day).format('YYYY-MM-DD')
        : dayjs(plan.service.end_day.toString()).format('YYYY-MM-DD'))
      : startDay

    // Format times
    const formatTime = (time) => {
      if (!time) return null
      const timeStr = time.toString().padStart(4, '0')
      return `${timeStr.slice(0, 2)}:${timeStr.slice(2)}`
    }

    const startHhmm = formatTime(plan.service.start_hhmm)
    const endHhmm = formatTime(plan.service.end_hhmm)

    // Convert service items
    const serviceItems = Array.isArray(plan.service.service_items)
      ? plan.service.service_items.map(item => {
        if (typeof item === 'object' && item.care_item_id) {
          return Number(item.care_item_id)
        }
        return Number(item)
      })
      : []

    // Handle staff assignments
    let staff1 = null
    let staff2 = null
    let staff3 = null
    if (Array.isArray(plan.staff)) {
      plan.staff.forEach((staff, index) => {
        const staffId = staff.id || staff.staff_id
        if (staffId) {
          switch (index) {
            case 0: staff1 = Number(staffId); break
            case 1: staff2 = Number(staffId); break
            case 2: staff3 = Number(staffId); break
          }
        }
      })
    }

    // Handle user
    const inputs = {
      start_day: startDay,
      start_hhmm: startHhmm,
      end_day: endDay,
      end_hhmm: endHhmm,
      service_type_id: Number(plan.service.service_type_id) || null,
      service_type_group_id: Number(plan.service.service_type_group_id) || null,
      service_code_id: Number(plan.service.service_code_id) || null,
      service_unique_code_id: Number(plan.service.service_unique_code_id) || null,
      service_teresa_unique_code_id: Number(plan.service.service_teresa_unique_code_id) || null,
      special_addition_cd: plan.service.special_addition_cd || '000',
      specific_office_addition_cd: plan.service.specific_office_addition_cd || '000',
      ownExpenseFlag: Boolean(plan.service.own_expense_flag),
      wheelchairTaxiFlag: Boolean(plan.service.wheelchair_taxi_flag),
      destination: plan.service.destination || '',
      instruction: plan.instruction || '',
      user: plan.user ? Number(plan.user.id) : null,
      service_items: serviceItems,
      staff1: staff1,
      staff2: staff2,
      staff3: staff3
    }

    return inputs
  } catch (error) {
    throw error
  }
}

watch(
  () => props.plan,
  (newVal) => {
    if (newVal) {
      try {
        id.value = newVal.id
        plan.value = newVal
        inputs.value = convertPlan2Inputs(newVal)
        isShiftMode.value = props.isShiftMode
      } catch (error) {
        console.error('Error in plan watcher:', error)
        toast.error('エラーが発生しました。')
      }
    }
  },
  { immediate: true, deep: true }
)

watch(
  () => inputs.value.user,
  (newVal, oldVal) => {
  },
  { immediate: true }
)

watch(
  () => inputs.value.service_type_id,
  (newVal, oldVal) => {
  },
  { immediate: true, deep: true }
)

// Replace toast ref with useToast
const toast = useToast()

// Validate form
const validateForm = () => {
  errors.value._errors = {}
  let isValid = true

  // Validate required fields
  if (!inputs.value.user) {
    errors.value._errors.user = '利用者を入力してください。'
    isValid = false
  }

  if (!inputs.value.start_day) {
    errors.value._errors.start_day = '日付を入力してください。'
    isValid = false
  }

  if (!inputs.value.start_hhmm) {
    errors.value._errors.start_hhmm = '開始時刻 を正しい書式で入力してください。'
    isValid = false
  }

  if (!inputs.value.end_hhmm) {
    errors.value._errors.end_hhmm = '終了時刻 を正しい書式で入力してください。'
    isValid = false
  }

  if (!inputs.value.service_type_id) {
    errors.value._errors.service_type_id = 'サービス種別を入力してください。'
    isValid = false
  }

  // Validate staff if in shift mode
  if (isShiftMode.value && !inputs.value.staff1) {
    errors.value._errors.staff1 = '担当者1は必須です'
    isValid = false
  }

  // Check destination max length
  if (inputs.value.destination && inputs.value.destination.length > 60) {
    errors.value._errors.destination = '行き先は60文字以内で入力してください'
    isValid = false
  }

  return isValid
}

const beforeOpen = async (event) => {
  try {
    isTaxi.value = (profile.value.site.function_mask & Constants.FunctionMask.TAXI) === Constants.FunctionMask.TAXI
    isSakura.value = (Constants.FunctionMask.SAKURA & profile.value.site.function_mask) === Constants.FunctionMask.SAKURA
    isNativeCode.value = (Constants.FunctionMask.NATIVE_CODE & profile.value.site.function_mask) === Constants.FunctionMask.NATIVE_CODE
    isTeresaStandard.value = (Constants.FunctionMask.TeresaStandard & profile.value.site.function_mask) === Constants.FunctionMask.TeresaStandard

    resetFormErrors()
    errors.value._errors = {}

    const dataSource = props.plan
    id.value = null
    isShiftMode.value = props.isShiftMode

    const defaultInputs = {
      start_day: dayjs().format('YYYY-MM-DD'),
      start_hhmm: null,
      end_day: dayjs().format('YYYY-MM-DD'),
      end_hhmm: null,
      service_type_id: null,
      service_type_group_id: null,
      specific_office_addition_cd: null,
      service_code_id: null,
      service_unique_code_id: null,
      service_teresa_unique_code_id: null,
      special_addition_cd: null,
      instruction: null,
      service_items: [],
      user: null,
      staff1: null,
      staff2: null,
      staff3: null,
      ownExpenseFlag: false,
      wheelchairTaxiFlag: false,
      destination: null
    }

    if (props.plan) {
      id.value = props.plan.id
      plan.value = props.plan
      inputs.value = convertPlan2Inputs(props.plan)
      isShiftMode.value = props.isShiftMode
    } else {
      inputs.value = defaultInputs
    }

    if (props.params) {
      plan.value = null
      const params = props.params

      if (params.start_day) inputs.value.start_day = utils.formatDay(params.start_day)
      if (params.start_hhmm) inputs.value.start_hhmm = utils.formatHHMM(params.start_hhmm)
      if (params.end_day) inputs.value.end_day = utils.formatDay(params.end_day)
      else if (params.start_day) inputs.value.end_day = inputs.value.start_day
      if (params.end_hhmm) inputs.value.end_hhmm = utils.formatHHMM(params.end_hhmm)
      if (params.staff_id) inputs.value.staff1 = Number(params.staff_id)
      if (params.user_id) inputs.value.user = Number(params.user_id)
    } else {
      id.value = dataSource.id
      load()
    }
  } catch (error) {
    toast.error('エラーが発生しました。')
  } finally {
    isLoading.value = false
  }
}

const load = async () => {
  if (id.value) {
    isLoading.value = true
    const res = await api.getPlan(id.value)
    return Promise.resolve(res)
      .then(res => {
        console.log('plan', res)
        store.commit('careplan/setOffice', res.office)
        inputs.value = convertPlan2Inputs(res)
        plan.value = res
      })
      .finally(() => {
        isLoading.value = false
      })
  }
}

const beforeClose = () => {
  if (isUpdated.value) {
    emit('refresh-data', {
      startDate: inputs.value.start_day.replace(/-/g, ''),
      endDate: computeServiceEndDayYmd(inputs.value),
      officeId: props.officeId,
      userId: inputs.value.user
    })
  }
  emit('close', isUpdated.value)
}

const close = () => {
  emit('cancel')
  showModal.value = false
}

const closeModal = () => {
  if (isUpdated.value) {
    emit('refresh-data', {
      startDate: inputs.value.start_day.replace(/-/g, ''),
      endDate: computeServiceEndDayYmd(inputs.value),
      officeId: props.officeId,
      userId: inputs.value.user
    })
  }
  showModal.value = false
  emit('update:modelValue', false)
  emit('close', isUpdated.value)
}

const handleOutsideClick = (event) => {
  if (event.target.classList.contains('vfm__overlay')) {
    closeModal()
  }
}

const destroy = async () => {
  try {
    isProcessing.value = true
    await store.dispatch('careplan/destroyPlan', id.value)
    toast.success('削除しました。')
    isUpdated.value = true
    showDeleteModal.value = false
    closeModal()
  } catch (error) {
    toast.error('エラーが発生しました。')
  } finally {
    isProcessing.value = false
  }
}

const register = async () => {
  // Validate form
  if (!validateForm()) {
    return
  }

  try {
    if (!inputs.value.start_day || !inputs.value.start_hhmm || !inputs.value.end_hhmm) {
      toast.error('開始時刻と終了時刻を入力してください。')
      return
    }

    // Convert inputs to plan data
    const planData = {
      id: id.value,
      office_id: props.officeId,
      instruction: inputs.value.instruction,
      staff: [
        inputs.value.staff1 && { staff_id: inputs.value.staff1 },
        inputs.value.staff2 && { staff_id: inputs.value.staff2 },
        inputs.value.staff3 && { staff_id: inputs.value.staff3 }
      ].filter(Boolean),
      user_id: inputs.value.user,
      service: {
        service_type_id: inputs.value.service_type_id,
        service_type_group_id: inputs.value.service_type_group_id,
        service_code_id: inputs.value.service_code_id,
        service_unique_code_id: inputs.value.service_unique_code_id,
        service_teresa_unique_code_id: inputs.value.service_teresa_unique_code_id,
        specific_office_addition_cd: inputs.value.specific_office_addition_cd || '000',
        special_addition_cd: inputs.value.special_addition_cd || '000',
        start_day: inputs.value.start_day.replace(/-/g, ''),
        start_hhmm: inputs.value.start_hhmm.replace(':', ''),
        end_day: computeServiceEndDayYmd(inputs.value),
        end_hhmm: inputs.value.end_hhmm.replace(':', ''),
        own_expense_flag: inputs.value.ownExpenseFlag ? 1 : 0,
        wheelchair_taxi_flag: inputs.value.wheelchairTaxiFlag ? 1 : 0,
        destination: inputs.value.destination,
        service_items: inputs.value.service_items.map(item => ({ care_item_id: Number(item) }))
      }
    }

    isProcessing.value = true

    await store.dispatch('careplan/savePlan', planData)

    toast.success('保存しました。')

    isUpdated.value = true

    emit('close', true)
    showModal.value = false
  } catch (error) {
    toast.error('エラーが発生しました。')
  } finally {
    isProcessing.value = false
  }
}

onMounted(() => {
  // Initialize Bootstrap tabs
  window.jQuery('[data-toggle="tab"]').tab()
})
</script>

<style>
/* Remove scoped to allow styles to affect child components */
.vfm__container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.plan-edit-modal {
  width: 1728px !important;
  min-height: 500px !important;
  margin: 49px auto !important;
  position: relative !important;
  background: white;
  border-radius: 4px;
  padding: 20px;
  overflow-y: auto;
}

.actions {
  background-color: white;
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-left: -20px;
}

@media (max-width: 1920px) {
  .plan-edit-modal {
    height: 80vh;
    width: 1728px !important;
    height: auto !important;
  }

  .plan-edit-modal .form-body {
    height: 80vh;
    overflow: scroll;
  }
}

.form-actions .btn {
  padding: 3px;
  margin: 0 8px;
}

/* Validation styles */
.is-invalid .form-control {
  border-color: #dc3545 !important;
}
</style>
